import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../Frames/Layout";
import { useEffect, useState } from "react";
import DPC from '../../../../services/API/DPC';
import { Alert, TextField, Stack, CircularProgress } from "@mui/material";
import FormButtons from "../../../Inputs/FormButtons";
import Toggle from "../../../Inputs/Toggle"
import useOptimisticUpdate from '../../../../services/ReactQuery/useOptimisticUpdate';
import API from "../../../../services/API";

export default function Form(){

    const navigate = useNavigate();

    const {id, actionId} = useParams();
    const isNew = id === 'new';

    const mutation = useOptimisticUpdate('dpc_sessions_' + actionId, () => null)

    const [item, setItem] = useState(null)
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        const defaultSession = {
            action: {id: actionId},
            status: {id: 'none'},
            closed: false
        };

        if(isNew){
            setItem(defaultSession)
        }else{
            DPC.getSession(id)
                .then(r => setItem(r.data))
                .catch(e => console.log(e))
        }

    }, [id, isNew, actionId])
    
 
    const handleSubmit = e => {
        e.preventDefault();

        (isNew ? API.post(`/dpc/sessions`, item) : API.put(`/dpc/sessions/${id}`, item))
            .then(r => handleSuccess(r))
            .catch(e => handleError(e))

        return setLoading(true);
    }

    const handleSuccess = r => {
        console.log(r?.data);
        mutation.mutate(item);
        return navigate(-1);
    }

    const handleError = e => {
        console.log(e.response?.data);

        let message = e.response?.status === 409 ?
            `L'identifiant ${item.id} est déjà utilisé.`
            : `Une erreur s'est produite, les données n'ont pas pu être enregistrées.`;

        setLoading(false);
        return setError(message);
    }


    return <Layout tab='sessions' menu='dpc' title='Session DPC' back>

        <Stack direction='row' justifyContent='center'>

            {item && <form onSubmit={handleSubmit}>

                <Stack direction='column' width={window.innerWidth < 800 ? 320 : 600} spacing={3} sx={{mb: 3}}>

                    {actionId === '0' && 
                        <TextField
                            label="Référence de l'Action"
                            type='number'
                            required
                            value={item.action.id === '0' ? '' : item.action.id}
                            onChange={e => setItem({...item, action: {id: e.target.value} })}
                            inputProps={{min: 1, step: 1}}
                            size='small'
                        />
                    }

                    <TextField
                        label='Identifiant'
                        type='number'
                        required
                        value={item.id || ''}
                        onChange={e => setItem({...item, id: e.target.value})}
                        inputProps={{min: 1, step: 1}}
                        size='small'
                        disabled={!isNew}
                    />

                    <TextField
                        label='Numéro de session'
                        required
                        value={item.number || ''}
                        onChange={e => setItem({...item, number: e.target.value.replaceAll(' ','')})}
                        size='small'
                    />

                    <TextField
                        label='Début de session'
                        type='date'
                        required
                        value={item.start || ''}
                        onChange={e => setItem({...item, start: e.target.value})}
                        size='small'
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        label='Fin de session'
                        type='date'
                        required
                        value={item.end || ''}
                        onChange={e => setItem({...item, end: e.target.value})}
                        size='small'
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        label="Fin de la formation continue"
                        type='date'
                        value={item.u2End || ''}
                        onChange={e => setItem({...item, u2End: e.target.value})}
                        size='small'
                        required
                        helperText="Date de fin de la formation continue"
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        label="Début de l'EPP final"
                        type='date'
                        value={item.u3Start || ''}
                        onChange={e => setItem({...item, u3Start: e.target.value})}
                        size='small'
                        helperText="Date de début de l'EPP final"
                        InputLabelProps={{ shrink: true }}
                    />

                    <Toggle 
                        label="Session ouverte"
                        value={!item.closed}
                        onChange={e => setItem({...item, closed: !item.closed})}
                    />

                    {false &&
                        <TextField
                            label="Soldé le"
                            type='date'
                            value={item.paidAt || ''}
                            onChange={e => setItem({...item, paidAt: e.target.value})}
                            size='small'
                            helperText="Date de règlement du solde par le DPC"
                            InputLabelProps={{ shrink: true }}
                        />
                    }
                    
                    <Toggle 
                        label="Classe virtuelle"
                        value={item.live ? true : false}
                        onChange={e => setItem({...item, live: 
                            (item.live ? null : {
                                id: '',
                                url: '', 
                                date: (item.end || ''), 
                                time: '20:00',
                            })
                        })}
                    />

                    {item.live && <>

                        <TextField
                            label="Lien de la classe virtuelle"
                            value={item.live.url || ''}
                            onChange={e => setItem({...item, live: 
                                {...item.live, url: e.target.value}
                            })}
                            size='small'
                        />

                        <TextField
                            label="ID du webinaire Zoom"
                            value={item.live.id || ''}
                            onChange={e => setItem({...item, live: 
                                {...item.live, id: e.target.value}
                            })}
                            size='small'
                        />

                        <TextField
                            label="Date de la classe virtuelle"
                            type='date'
                            value={item.live.date || ''}
                            onChange={e => setItem({...item, live: 
                                {...item.live, date: e.target.value}
                            })}
                            size='small'
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            label="Heure de la classe virtuelle"
                            type='time'
                            value={item.live.time || ''}
                            onChange={e => setItem({...item, live: 
                                {...item.live, time: e.target.value}
                            })}
                            size='small'
                            InputLabelProps={{ shrink: true }}
                        />

                    </>}

                    {error && <Alert severity='error'>{error}</Alert>}
                    
                    <FormButtons onCancel={() => navigate(-1)} loading={loading}/>

                </Stack>

            </form>}

            {!item && <CircularProgress size={30}/>}

        </Stack>

    </Layout>
}
